import {RoleModel} from './Role.model';
import {AccessLogModel} from './AccessLog.model';

export class PowerBiObjectModel {
    public id: number;
    public currentUserAzureObjectId: string;
    public azureWorkspaceId: string;
    public azureObjectId: string;
    public roles: Array<RoleModel>;
    public isDashboard: boolean;
    public isReport: boolean;
    public isCubeConnection: boolean;
    public displayFilterTable: boolean;
    public customName: string;
    public accessLog: Array<AccessLogModel>;

    public name: string;

    constructor() {
        this.roles = new Array<RoleModel>();
        this.accessLog = new Array<AccessLogModel>();
    }
}
